import Vue from 'vue'
import VueCookies from 'vue-cookies'
import Storage from 'vue-ls';
import Survey from '../components/Survey.vue';



Vue.config.productionTip = false;

Vue.use(VueCookies)
Vue.use(Storage, {
    namespace: 'igr_',
    name: 'ls',
    storage: 'local',
});

new Vue({
    el: '#survey',
    render: function (h) {
        return h(Survey);
    },
    data: {

    },
    components: {
        Survey
    },
    created() {
        this.$cookies.config('30d');
    },
});
